<script setup>
  import { ref, watch } from "vue";

  const sheet = ref(false);

  const emit = defineEmits(["toggleSidebar"]);

  const showContent = ref(false);

  const fontSize = (size) => {
    document.documentElement.style.fontSize = `${size}px`;
  };
</script>
<template>
  <div class="pr-2 text-center">
    <!-- <v-icon
      variant="text"
      icon="fas fa-cog"
      color="black"
      title="Search"
      @click="sheet = !sheet"
    ></v-icon> -->

    <transition
      name="fade"
      @after-enter="showContent = true"
    >
      <div
        v-if="sheet"
        class="modal"
        @click="showContent = false"
      >
        <transition
          name="slide-fade"
          @after-leave="sheet = !sheet"
        >
          <div
            v-if="showContent"
            class="content"
            @click.stop
          >
            <div>
              <v-switch
                v-model="isDark"
                :label="`Theme: ${isDark ? 'Dark' : 'Light'}`"
                inset
              ></v-switch>

              <!-- font size -->
              <!-- <div class="d-flex gap-4 align-center">
                <v-icon
                  size="small"
                  variant="text"
                  icon="fas fa-font"
                  color="black"
                  title="Search"
                  @click="fontSize(10)"
                ></v-icon>
                <v-icon
                  variant="text"
                  icon="fas fa-font"
                  color="black"
                  title="Search"
                  @click="fontSize(16)"
                ></v-icon>
                <v-icon
                  size="large"
                  variant="text"
                  icon="fas fa-font"
                  color="black"
                  title="Search"
                  @click="fontSize(20)"
                ></v-icon>
              </div> -->
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: 0.1s opacity ease-out;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
  }
  .content {
    position: absolute;
    top: 0;
    right: 0;
    width: 400px;
    height: 100vh;
    background: #fff;
    padding: 20px;
    line-height: 1.5;
    font-size: 18px;
    color: #444;
    box-shadow:
      0 3px 6px rgba(0, 0, 0, 0.16),
      0 3px 6px rgba(0, 0, 0, 0.23);
  }

  .side-sheet {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 5000;

    &__content {
      width: 300px;
      background-color: white;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-leave-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(400px);
  }
</style>
